<template>
    <main-content>
        <action-bar>
            <router-link to="/online-factor-item-create" class="btn btn-success">{{ $t('online-factor.label_create_item') }}</router-link>
        </action-bar>
        <online-factor-filter :action="filterAction"></online-factor-filter>
        <div v-if="$can('read', 'payment-link')">
            <kt-datatable ref="datatable" v-bind="datatablePropsWithManage" v-on:change="filterAction"></kt-datatable>
        </div>
        <div v-else>
            <kt-datatable ref="datatable" v-bind="datatableProps" v-on:change="filterAction"></kt-datatable>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import Filter from './components/filter_item'
import { ShopApiUrl } from '@/common/api.service';
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from './datatable/columns_items';
import manageColumns from './datatable/columnsWithManageAccess_items';
import actionsColumn from './components/actions-column'
import actionsColumnWithManageAccess from './components/actionsColumnWithManageAccess'
import actionBar from '@/components/custom/action-bar'

export default {
    name: 'online-factor-get-items',
    components:{
        'main-content': mainContent,
        'online-factor-filter': Filter,
        'action-bar': actionBar
    },
    data() {
       return {
           query: {

           }
       }
    },
    computed: {
        datatablePropsWithManage() {
            return {
                id: 'datatableWithManageAccess',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ShopApiUrl.path('item?is_admin_panel=true'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: manageColumns,
                actions: actionsColumnWithManageAccess
            }
        },
        datatableProps() {
            return {
                id: 'datatable',
                data: {
                   type: 'remote',
                   source: {
                       read: {
                           url: ShopApiUrl.path('item'),
                           method: 'GET',
                           headers: AuthorizationHeader,
                           map: function(res) {
                               return res.data.data
                           },
                           params: {
                               query: this.query
                           },
                       }
                   },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    },
}
</script>